import { apiRequest } from './apiRequest'
import { ApiColor, ApiVehicleType, ApiLoadType, ApiChassisType } from '../models/api'
import {
    ChassisType,
    ChassisTypeDirectory,
    LoadTypeDirectory,
    LoadType,
    VehicleType,
    ColorDirectory,
    Color,
    VehicleTypeDirectory,
} from '../models/client/metadata'

const getColors = async (params: { token: string }): Promise<ColorDirectory> => {
    // const { data: apiColors } = await apiRequest<ApiColor[]>({
    //     method: 'GET',
    //     path: '/colors',
    //     token: params.token
    // })
    const colorDirectory: Record<string, Color> = {}
    // apiColors.forEach((color) => {
    //     colorDirectory[color.name] = color
    // })
    return colorDirectory
}

const getVehicleTypes = async (params: { token: string }): Promise<VehicleTypeDirectory> => {
    const { data: response } = await apiRequest<ApiVehicleType[]>({
        method: 'GET',
        path: '/vehicle_types',
        token: params.token,
        disableCache: false,
    })
    const directory: Record<string, VehicleType> = {}
    response.forEach((item) => {
        directory[item.name] = item
    })
    return directory
}

const getLoadTypes = async (params: { token: string }): Promise<LoadTypeDirectory> => {
    const { data: response } = await apiRequest<ApiLoadType[]>({
        method: 'GET',
        path: '/load_types',
        token: params.token,
        disableCache: false,
    })
    const directory: Record<string, LoadType> = {}
    response.forEach((item) => {
        directory[item.name] = item
    })
    return directory
}

const getChassisTypes = async (params: { token: string }): Promise<ChassisTypeDirectory> => {
    const { data: response } = await apiRequest<ApiChassisType[]>({
        method: 'GET',
        path: '/chassis_types',
        token: params.token,
    })
    const directory: Record<string, ChassisType> = {}
    response.forEach((item) => {
        directory[item.name] = item
    })
    return directory
}

export const metadataClient = {
    getColors,
    getVehicleTypes,
    getLoadTypes,
    getChassisTypes,
}
